import {
  BOOST,
  INDEED,
  JOVEO,
  POOL,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';

/**
 * Get the default values for a channel. Setting these values for the channel impacts their channel form
 * duration - fixes the duration of the campaign. The input is made read only.
 * budget - fixes the per openingbudget of the campaign. The input is made read only.
 * minBudget - minimum budget per opening for the channel. Throws a validation error if the budget is less than the minimum budget.
 * minDuration - minimum duration of the campaign. The user is not allowed to set a duration less than the minimum duration.
 */
export const getChannelDefaults = (channelSlug: string) => {
  switch (channelSlug) {
    case ZIPRECRUITER:
      return {
        duration: 30,
        budget: 149,
      };
    case BOOST:
      return {
        duration: 30,
        minBudget: 150,
      };
    case INDEED:
      return {
        minDuration: 7,
      };
    case POOL:
      return {
        minDuration: 2,
      };
    case JOVEO:
      return {
        minBudget: 100,
        minDuration: 15,
      };
    case TALROO:
      return {
        duration: 30,
      };
    default:
      return {
        minBudget: 50,
      };
  }
};
